export default __webpack_public_path__ + "static/media/Logo_Gulliver_simpe_black_new.20e42e83.svg";